<template><span></span></template>

<script setup lang="ts">
import { editorProps } from "./Editor";
import { defineProps } from "vue";

const props = defineProps({
	...editorProps,
});
</script>
